"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Select = exports.useSelect = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importStar(require("react"));
const react_intl_1 = require("react-intl");
const ThemeProvider_1 = require("../../utils/ThemeProvider");
const Utils_1 = require("../../utils/Utils");
const icons_1 = require("../../assets/icons");
const Label_1 = require("../Label/Label");
const StyleUtils_1 = require("../../utils/StyleUtils");
const Select_styles_1 = require("./styles/Select.styles");
const Option_1 = require("./Option");
const NativeSelect_1 = require("./NativeSelect");
const __DEV__ = process.env.NODE_ENV !== 'production';
const SelectContext = (0, react_1.createContext)({
    handleOnChange: () => { },
    selectedOption: undefined,
    dropdownOpen: false,
    selectStyles: undefined,
    useNative: false,
});
const useSelect = () => (0, react_1.useContext)(SelectContext);
exports.useSelect = useSelect;
const Select = (props) => {
    var _a, _b, _c, _d;
    const { children, label, name, id = name, className = '', testId, defaultValue, hasError = false, disabled = false, placeholder = '', helperMessage, shouldHideLabel = false, allowSearch = false, onChange, onFocus, onBlur, onClick, onKeyDown, useNative = false, } = props;
    const theme = (0, ThemeProvider_1.useTheme)();
    const intl = (0, react_intl_1.useIntl)();
    if (!theme) {
        if (__DEV__) {
            console.error('`Select` component must be a child of a `ThemeProvider`');
        }
        return null;
    }
    if (!intl) {
        if (__DEV__) {
            console.error('`Select` component must be a child of a `IntlProvider`');
        }
        return null;
    }
    const childrenArray = react_1.default.Children.toArray(children).map((c, index) => react_1.default.cloneElement(c, Object.assign({ dataIndex: index, key: index }, c.props)));
    const [state, setState] = (0, react_1.useState)({
        hasFocus: false,
        showDropdown: false,
        currentValue: (_a = childrenArray.find(c => c.props.value === defaultValue)) === null || _a === void 0 ? void 0 : _a.props.value,
        options: childrenArray,
        searchValue: (_c = (_b = childrenArray.find(c => c.props.value === defaultValue)) === null || _b === void 0 ? void 0 : _b.props.name) !== null && _c !== void 0 ? _c : '',
    });
    const optionIndex = (0, react_1.useRef)(-1);
    const dropdownRef = (0, react_1.createRef)();
    const inputRef = (0, react_1.createRef)();
    const selectContainerRef = (0, react_1.createRef)();
    const selectRef = (0, react_1.createRef)();
    const styles = (0, Select_styles_1.getSelectStyles)();
    const dti = (0, Utils_1.getTestIdAttribute)(testId);
    const helperContent = (el) => ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: (0, StyleUtils_1.classNames)('Select-helperContainer-local', styles.helperContainer, hasError && styles.errorMessage) }, (0, Utils_1.getTestIdAttribute)('selectHelperContent'), { children: el })));
    const noSearchResults = () => ((0, jsx_runtime_1.jsx)("li", Object.assign({ className: (0, StyleUtils_1.classNames)(styles.noResultsContainer) }, { children: (0, jsx_runtime_1.jsx)("p", Object.assign({ className: (0, StyleUtils_1.classNames)(styles.noResults) }, { children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "select.noResults", defaultMessage: "Sorry, no results found.", description: "Select no results message" }) })) })));
    const handleOnClick = (e) => {
        if (disabled)
            return;
        if (onClick)
            onClick(e);
        if (useNative)
            return;
        if (state.hasFocus && state.showDropdown)
            setState(Object.assign(Object.assign({}, state), { showDropdown: false }));
        else {
            // timeout to allow other events to finish before showing
            setTimeout(() => {
                setState(Object.assign(Object.assign({}, state), { hasFocus: true, showDropdown: true }));
            });
        }
    };
    const handleArrowPress = (e) => {
        // prevent window scroll
        e.preventDefault();
        switch (e.key) {
            case 'ArrowDown':
                if (state.showDropdown) {
                    optionIndex.current = optionIndex.current === state.options.length - 1 ? 0 : optionIndex.current + 1;
                }
                break;
            case 'ArrowUp':
                if (state.showDropdown) {
                    optionIndex.current = optionIndex.current === 0 ? state.options.length - 1 : optionIndex.current - 1;
                }
                break;
            default:
        }
        setState(Object.assign(Object.assign({}, state), { hasFocus: true, showDropdown: true }));
        handleScrollDropdown();
    };
    const handleKeyDown = (e) => {
        e.stopPropagation();
        if (disabled)
            return;
        if (useNative)
            return;
        if (onKeyDown)
            onKeyDown(e);
        switch (e.key) {
            case 'Enter':
                // Prevent form from submitting on enter
                e.preventDefault();
                if (state.showDropdown) {
                    const newOption = state.options.find((o) => o.props.dataIndex === optionIndex.current);
                    if (!newOption.props.disabled)
                        handleOnChange({ name: newOption === null || newOption === void 0 ? void 0 : newOption.props.name, value: newOption === null || newOption === void 0 ? void 0 : newOption.props.value });
                }
                else
                    setState(Object.assign(Object.assign({}, state), { showDropdown: true }));
                break;
            case ' ':
                if (!allowSearch) {
                    setState(Object.assign(Object.assign({}, state), { showDropdown: !state.showDropdown }));
                }
                break;
            case 'ArrowDown':
                handleArrowPress(e);
                break;
            case 'ArrowUp':
                handleArrowPress(e);
                break;
            case 'Escape':
                setState(Object.assign(Object.assign({}, state), { showDropdown: false }));
                break;
            default:
        }
    };
    const handleScrollDropdown = () => {
        const prev = document.querySelector('.Select-option-focused');
        if (prev)
            prev.classList.remove('Select-option-focused');
        const option = document.querySelector(`.Select-option-local[data-option-index='${optionIndex.current}']`);
        if (option && dropdownRef.current) {
            option === null || option === void 0 ? void 0 : option.classList.add('Select-option-focused');
            dropdownRef.current.scrollTop = option.offsetTop;
        }
    };
    const handleOnFocus = (e) => {
        if (disabled)
            return;
        if (onFocus)
            onFocus(e);
        if (useNative)
            return;
        if (allowSearch)
            inputRef.current.focus();
        setState(Object.assign(Object.assign({}, state), { hasFocus: true }));
    };
    const handleOnBlur = (e) => {
        var _a, _b, _c;
        if (disabled)
            return;
        if (useNative)
            return;
        if (!((_a = selectContainerRef.current) === null || _a === void 0 ? void 0 : _a.contains(e.relatedTarget))) {
            if (onBlur)
                onBlur(e);
            setState(Object.assign(Object.assign({}, state), { options: childrenArray, searchValue: (_c = (_b = state.options.find(c => c.props.value === state.currentValue)) === null || _b === void 0 ? void 0 : _b.props.name) !== null && _c !== void 0 ? _c : '', hasFocus: false, showDropdown: false }));
        }
    };
    const handleOnChange = (selectedOption) => {
        var _a, _b;
        if (disabled)
            return;
        if (onChange)
            onChange(selectedOption.value);
        if (useNative)
            return;
        const option = childrenArray.find(o => o.props.value === selectedOption.value);
        // set current option index
        optionIndex.current = (_a = option === null || option === void 0 ? void 0 : option.props.dataIndex) !== null && _a !== void 0 ? _a : -1;
        setState(Object.assign(Object.assign({}, state), { currentValue: selectedOption.value, searchValue: (_b = selectedOption.name) !== null && _b !== void 0 ? _b : '', showDropdown: false, options: childrenArray }));
    };
    const handleInputChange = (e) => {
        const searchTerm = e.currentTarget.value;
        const searchOptions = childrenArray.filter((o) => {
            var _a, _b;
            let isMatch = false;
            (_a = o.props.keywords) === null || _a === void 0 ? void 0 : _a.split(',').forEach((keyword) => {
                const term = keyword.trim().toLowerCase();
                if (term.includes(searchTerm.toLowerCase()))
                    isMatch = true;
            });
            if ((_b = o.props.name) === null || _b === void 0 ? void 0 : _b.toLowerCase().includes(searchTerm.toLowerCase()))
                isMatch = true;
            return isMatch;
        });
        optionIndex.current = -1;
        const constructedSearchOptions = searchOptions.map((o, i) => react_1.default.cloneElement(o, { dataIndex: i }));
        const results = searchTerm.length === 0
            ? childrenArray
            : constructedSearchOptions.length === 0
                ? [noSearchResults()]
                : constructedSearchOptions;
        setState(Object.assign(Object.assign({}, state), { options: results, searchValue: searchTerm, showDropdown: true }));
    };
    const providerValue = (0, react_1.useMemo)(() => ({
        handleOnChange,
        selectedOption: state.currentValue,
        dropdownOpen: state.showDropdown,
        useNative,
    }), [state.currentValue, state.showDropdown, defaultValue, useNative]);
    const handleNativeOnChange = (value) => {
        if (onChange)
            onChange(value);
    };
    const handleNativeOnBlur = (e) => {
        if (onBlur)
            onBlur(e);
    };
    const handleNativeOnFocus = (e) => {
        if (onFocus)
            onFocus(e);
    };
    const handleNativeOnClick = (e) => {
        if (onClick)
            onClick(e);
    };
    (0, react_1.useEffect)(() => {
        if (state.showDropdown) {
            if (allowSearch)
                inputRef.current.focus();
            handleScrollDropdown();
        }
        if (!useNative) {
            dropdownRef.current.style.top = `${selectRef.current.clientHeight + 2}px`;
        }
    }, [state]);
    (0, react_1.useEffect)(() => {
        var _a, _b;
        const option = childrenArray.find((o) => o.props.value === defaultValue);
        if (defaultValue) {
            // set current option index
            optionIndex.current = (_a = option === null || option === void 0 ? void 0 : option.props.dataIndex) !== null && _a !== void 0 ? _a : -1;
        }
        else
            optionIndex.current = -1;
        setState(Object.assign(Object.assign({}, state), { currentValue: option === null || option === void 0 ? void 0 : option.props.value, searchValue: (_b = option === null || option === void 0 ? void 0 : option.props.name) !== null && _b !== void 0 ? _b : '' }));
    }, [defaultValue]);
    return ((0, jsx_runtime_1.jsx)(SelectContext.Provider, Object.assign({ value: providerValue }, { children: useNative ? ((0, jsx_runtime_1.jsx)(NativeSelect_1.NativeSelect, Object.assign({ name: name, label: label, className: className, disabled: disabled, defaultValue: defaultValue, id: id, testId: testId, hasError: hasError, shouldHideLabel: shouldHideLabel, helperMessage: helperMessage, onFocus: handleNativeOnFocus, onChange: handleNativeOnChange, onBlur: handleNativeOnBlur, onClick: handleNativeOnClick }, { children: [react_1.default.createElement('option', { value: '', key: 'option', children: placeholder !== null && placeholder !== void 0 ? placeholder : '' }), ...childrenArray] }))) : ((0, jsx_runtime_1.jsxs)("div", Object.assign({ className: (0, StyleUtils_1.classNames)('Select-container-local', styles.container), ref: selectContainerRef }, { children: [(0, jsx_runtime_1.jsxs)("div", Object.assign({ id: id, role: allowSearch ? 'search' : 'button', "aria-disabled": disabled, "aria-label": name, ref: selectRef, tabIndex: disabled ? -1 : 0, className: (0, StyleUtils_1.classNames)('Select-local', styles.wrapper, className, hasError && styles.hasError, disabled && styles.disabled, state.hasFocus && styles.focus, state.showDropdown && styles.dropdownOpen), onFocus: handleOnFocus, onBlur: handleOnBlur, onMouseDown: handleOnClick, onKeyDown: handleKeyDown }, dti, { children: [(0, jsx_runtime_1.jsx)(Label_1.Label, { htmlFor: id, content: !shouldHideLabel ? label : undefined, screenReaderOnlyText: shouldHideLabel ? label : undefined, className: (0, StyleUtils_1.classNames)(styles.label, disabled && styles.disabled, hasError && styles.hasError) }), (0, jsx_runtime_1.jsxs)("div", Object.assign({ className: (0, StyleUtils_1.classNames)('Select-innerWrapper-local', styles.innerWrapper) }, { children: [allowSearch ? ((0, jsx_runtime_1.jsx)("input", Object.assign({ ref: inputRef, disabled: disabled, "aria-label": name, className: (0, StyleUtils_1.classNames)('Select-input-local', styles.searchInput, styles.content), value: (_d = state.searchValue) !== null && _d !== void 0 ? _d : '', placeholder: placeholder, onChange: handleInputChange, onKeyDown: handleKeyDown }, (0, Utils_1.getTestIdAttribute)('selectSearchInput')))) : ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: (0, StyleUtils_1.classNames)('Select-content-local', styles.content) }, { children: state.searchValue.length > 0 ? state.searchValue : placeholder }))), (0, jsx_runtime_1.jsx)(icons_1.DownIcon, { className: (0, StyleUtils_1.classNames)(styles.icon, state.showDropdown && styles.rotate) })] }))] })), !useNative && ((0, jsx_runtime_1.jsx)("ul", Object.assign({ className: (0, StyleUtils_1.classNames)('Select-dropdownContainer-local', styles.dropdownContainer, hasError && styles.hasError, state.showDropdown && styles.visible), role: "presentation", ref: dropdownRef, onKeyDown: handleKeyDown, onBlur: handleOnBlur }, (0, Utils_1.getTestIdAttribute)('selectDropdown'), { children: state.showDropdown ? state.options : null }))), helperMessage && helperContent(helperMessage)] }))) })));
};
exports.Select = Select;
Select.Option = (props) => (0, jsx_runtime_1.jsx)(Option_1.Option, Object.assign({}, props, { children: props.children }));
